<template>
  <div class="test-wait-for-input-bubble grid grid-cols-5">
    <div class="col-start-3 col-span-5 border border-solid border-gray rounded p-4 flex justify-between items-center text-gray-dark hover:border-focus hover:cursor-pointer test-wait-for-input"
        :class="bubbleClasses"
        @click="selectWaitForInput"
    >
      <div class="flex items-center">
        <span v-html="bubbleText"/>
        <img v-if="validationParams" :src="waitValidationIcon" alt="wait validation icon" height="22" class="ml-2"/>
      </div>
      <wait-for-input-icon class="h-6 w-6" />
    </div>
  </div>
</template>

<script>
import chatBubbleModule from '@/store/modules/chat-bubble.module'
import previewModule from '@/store/modules/preview.module'
import WaitForInputIcon from '@/assets/images/icons/WaitForInputIcon'
import conversationModule from '@/store/modules/conversation.module'
import waitValidationIcon from '@/assets/images/icons/wait_validation_icon.svg'

export default {
  name: 'WaitForInputBubble',
  components: { WaitForInputIcon },

  props: {
    stateId: { type: String, required: true },
    nextStateId: { type: String, default: null },
    validationActionId: { type: String, default: null },
    focus: { type: Boolean, required: true },
    isTemplate: { type: Boolean, required: true },
    contextStateId: { type: String, default: null },
    inNestedCondition: { type: Boolean, default: false }
  },

  data() {
    return {
      waitValidationIcon
    }
  },

  computed: {
    bubbleSelected: chatBubbleModule.bubbleSelected,
    error: previewModule.error,

    validationParams() {
      if (!this.validationActionId) return null

      return conversationModule.getAction(this.stateId, this.validationActionId).params
    },

    bubbleText() {
      return `Waiting for customer's <b>${this.validationParams?.label || 'input'}</b>...`
    },

    bubbleClasses() {
      if (chatBubbleModule.isErrorBubbleFocused() && this.validationActionId === this.error.actionId) return 'border-focus-error'

      return this.focus ? 'border-focus bubble-shadow' : ''
    }
  },

  methods: {
    selectWaitForInput() {
      chatBubbleModule.selectWaitForInput(this.stateId, this.nextStateId, this.validationActionId, this.contextStateId, this.isTemplate, this.inNestedCondition)
    }
  }
}
</script>

<style lang="scss" scoped>

.bubble-shadow {
  // noinspection CssInvalidFunction - theme() belongs to TailWind
  box-shadow: 0 4px 11px 0 theme('colors.focus-a50');
}

</style>
